import { L10n } from '@flippingbook/web.react-kit/dist/L10n';

import { loc } from '@/localization';

import { MessagePage } from '../message';

function Message({ email }: SuccessMessagePage.Props) {
    return (
        <L10n
            text={loc.Login.RestorePasswordCompleted}
            replaces={[['{email}', email.trim() ? <strong>{email}</strong> : loc.Login.You]]}
        />
    );
}

export function SuccessMessagePage({ email }: SuccessMessagePage.Props) {
    return <MessagePage message={<Message email={email} />} />;
}

namespace SuccessMessagePage {
    export interface Props {
        email: string;
    }
}
